function expectedStatementSupportedRadioDirective(): ng.IDirective {
    return {
        restrict: "AE",
        replace: true,
        scope: {
            statement: "=",
            yearAndMonth: "=",
            july2024: "=",
            october2025: "=",
        },
        templateUrl: "app/funding/directives/partials/expectedStatementSummary.html"
    };
}
export = expectedStatementSupportedRadioDirective;
